import React from 'react';

const Header = ({ user, onLogout }) => (
  <div className="flex justify-between items-center p-4 bg-white shadow-sm">
    <h1 className="text-2xl font-bold">Dashboard</h1>
    <div className="flex items-center">
      <span className="mr-4">Welcome, {user?.email}</span>
      <button onClick={onLogout} className="bg-red-500 text-white px-4 py-2 rounded">Logout</button>
    </div>
  </div>
);

export default Header;
